export  const closeModel=(id)=> {
    if(document.getElementById(id)){
        document.getElementById(id).style.display='none';
        document.getElementById(id).classList.remove('show');
        document.getElementsByClassName("modal-backdrop")[0]?.remove();
    }
}